import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaCheckCircle } from 'react-icons/fa';
import './Services.css';

const Services = () => {
  const services = [
    {
      title: 'Professional Badminton Coaching',
      description: 'Our professional badminton coaching service is led by experienced and certified coaches who provide structured, high-quality training. This service focuses on developing correct techniques, strong fundamentals, and advanced skills. Players are trained in proper grips, footwork, strokes, and game strategies, ensuring steady progress and improved performance at all levels.',
      link: '/Professional-Badminton-Coaching',
      image: 'img/Professional Badminton Coaching.jpg'
    },
    {
      title: 'Training Programs',
      description: 'This program is specially designed for beginners who are new to badminton. Training starts with the basics of the game, including rules, court positioning, and basic strokes. The sessions are conducted in a friendly and encouraging environment, helping new players build confidence, coordination, and a strong foundation in badminton.',
      link: '/Training-Programs',
      image: 'img/Training Programs.jpg'
    },
    {
      title: 'Intermediate & Advanced Training Program',
      description: 'For players with prior experience, this service focuses on refining techniques and improving consistency. Training includes advanced stroke play, footwork drills, tactical awareness, and match strategies. Players are prepared for competitive play with regular practice matches and performance feedback.',
      link: '/Intermediate-Advanced-Training-Program',
      image: 'img/Intermediate Training Program.jpg'
    },
    {
      title: 'Youth Development Program',
      description: 'Our youth development program is aimed at identifying and nurturing young talent at an early age. This service focuses on age-appropriate training methods that promote skill development, discipline, and sportsmanship. Young players are trained to build confidence, fitness, and a competitive mindset while enjoying the sport.',
      link: '/Youth-Development-Program',
      image: 'img/Youth Development Program.jpg'
    },
    {
      title: 'Fitness & Conditioning Training',
      description: 'Badminton demands speed, agility, stamina, and strength. Our fitness and conditioning service is designed to improve overall athletic performance. It includes agility drills, endurance training, strength exercises, flexibility routines, and injury-prevention practices, helping players stay fit and perform better on the court.',
      link: '/Fitness-Conditioning-Training',
      image: 'img/Fitness & Conditioning Training.jpg'
    },
    {
      title: 'Match Practice & Tournament Preparation',
      description: 'This service focuses on preparing players for real match situations. Regular practice matches, internal tournaments, and strategic training sessions help players develop match temperament, decision-making skills, and confidence. Players are guided on tournament preparation, rules, and performance handling under pressure.',
      link: '/Match-Practice-Tournament-Preparation',
      image: 'img/Match Practice & Tournament Preparation.jpg'
    },
    {
      title: 'Personal Coaching & Skill Development',
      description: 'For players who require individual attention, we offer personal coaching sessions. These sessions are customized to address specific areas such as footwork, smash technique, net play, or fitness. Personalized training helps accelerate improvement and target individual goals.',
      link: '/Personal-Coaching-Skill-Development',
      image: 'img/Personal Coaching & Skill Development.jpg'
    },
    {
      title: 'Recreational & Fitness Badminton',
      description: 'This service is ideal for adults and working professionals who want to stay fit while enjoying badminton. It focuses on regular play, basic skill improvement, and fitness, offering a stress-free and enjoyable sports experience in a professional environment.',
      link: '/Recreational-Fitness-Badminton',
      image: 'img/Recreational & Fitness Badminton.jpg'
    }
  ];

  const additionalServices = [
    { icon: '🎾', title: 'Equipment Rental', description: 'Rackets and shuttlecocks available for rent' },
    { icon: '🚿', title: 'Locker & Showers', description: 'Modern changing facilities with secure lockers' },
    { icon: '☕', title: 'Refreshments', description: 'Café with healthy snacks and beverages' },
    { icon: '📹', title: 'Video Analysis', description: 'Record and review your gameplay' },
    { icon: '🏋️', title: 'Fitness Area', description: 'Warm-up and fitness equipment available' },
    { icon: '🅿️', title: 'Free Parking', description: 'Ample parking space for members' }
  ];

  return (
    <div className="services-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="page-header-overlay"></div>
        <div className="container">
          <div className="page-header-content">
            <span className="page-badge">What We Offer</span>
            <h1>Our Services</h1>
            <p>Comprehensive badminton services for players of all levels</p>
            <nav className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <span>Services</span>
            </nav>
          </div>
        </div>
      </section>

      {/* Main Services Section */}
      <section className="main-services section">
        <div className="container">
          <div className="section-header center">
            <span className="section-badge">Core Services</span>
            <h2>Everything You Need for Badminton</h2>
            <p>From casual play to competitive training, we've got you covered</p>
          </div>
          <div className="services-list">
            {services.map((service, index) => (
              <div className={`service-row ${index % 2 !== 0 ? 'reverse' : ''}`} key={index}>
                <div className="service-image">
                  <img src={service.image} alt={service.title} />
                </div>
                <div className="service-info">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <Link to={service.link} className="btn btn-primary">
                    Learn More <FaArrowRight />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Services */}
      <section className="additional-services section">
        <div className="container">
          <div className="section-header center">
            <span className="section-badge">Amenities</span>
            <h2>Additional Facilities</h2>
            <p>Extra services to enhance your experience at Net Nest</p>
          </div>
          <div className="amenities-grid">
            {additionalServices.map((item, index) => (
              <div className="amenity-card" key={index}>
                <span className="amenity-icon">{item.icon}</span>
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Get Started?</h2>
            <p>Contact us to learn more about our services or book a visit</p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn btn-white">Contact Us</Link>
              <Link to="/membership" className="btn btn-outline-white">View Membership</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
